module.exports = __webpack_public_path__ + "img/noti-phone-large.d36f4471.png";